import { Tabs } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';
import SearchForm from '../../components/SearchForm/SearchForm';
import ApplicantMenteeTab from './ApplicantMenteeTab/ApplicantMenteeTab';
import styles from './BackofficeUpgradeRequestsList.module.scss';
import MenteeTab from './MenteeTab/MenteeTab';
import { useBackofficeUpgradeRequestsList } from './useBackofficeUpgradeRequestsList';

const BackofficeUpgradeRequestsList = () => {
	const { onSearchByTerm, state: { searchTerm } } = useBackofficeUpgradeRequestsList();
	const { TabPane } = Tabs;

	const location: any = useLocation();
	const { activeTab } = location.state || {};

	return <div className={styles.pageContainer}>
			<div className={`${styles.pageSider} ${styles.topBorder}`}>
				<SearchForm onSearchByTerm={onSearchByTerm} />
			</div>


			<div className={styles.pageContent}>
					<div className={styles.mobileTopper}>		
				<SearchForm onSearchByTerm={onSearchByTerm} />
			</div>

			<Tabs
				defaultActiveKey={activeTab?.toString() || "1"}
				destroyInactiveTabPane={true}
			>
				<TabPane
					key="1"
					tab={<><FormattedMessage id="navigation.menteeUpgrade" />
						<span className={styles.tabDivider}>/</span>
					</>}
				>
					<MenteeTab  searchTerm={searchTerm}/>
				</TabPane>
				<TabPane
					key="2"
					tab={<FormattedMessage id="navigation.applicantMenteeUpgrade" />}
				>
					<ApplicantMenteeTab searchTerm={searchTerm}/>
				</TabPane>
			</Tabs>
		</div>
	</div>
}
export default BackofficeUpgradeRequestsList;